import { useTranslation } from "react-i18next";
import "../../../styles/UserAuthPage.css";

function LeftPanel() {
  const { t } = useTranslation();

  return (
    <div className="authPage__visual">
      <div className="authPage__overlay" />

      <div className="authPage__content">
        <h1 className="authPage__heading">{t("auth.imageTitle")}</h1>

        <p className="authPage__text">{t("auth.imageSubTitle")}</p>

        <div className="authPage__stats">
          <div className="authPage__stat">
            <strong>2</strong>
            <span>{t("auth.pilotStates")}</span>
          </div>

          <div className="authPage__stat">
            <strong>{t("auth.live")}</strong>
            <span>{t("auth.soilData")}</span>
          </div>

          <div className="authPage__stat">
            <strong>{t("auth.smart")}</strong>
            <span>{t("auth.recommendations")}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LeftPanel;
